/**
 * Cart Upsell Quantity Selector
 * Simple quantity increase/decrease functionality
 */

class CartUpsell {
  constructor() {
    this.init();
  }

  init() {
    this.bindQuantityEvents();
  }

  bindQuantityEvents() {
    document.addEventListener('click', (e) => {
      // Handle quantity decrease
      const decreaseBtn = e.target.closest('.cart-upsell-block__quantity-btn--decrease');
      if (decreaseBtn) {
        e.preventDefault();
        this.decreaseQuantity(decreaseBtn);
      }

      // Handle quantity increase
      const increaseBtn = e.target.closest('.cart-upsell-block__quantity-btn--increase');
      if (increaseBtn) {
        e.preventDefault();
        this.increaseQuantity(increaseBtn);
      }
    });

    // Handle direct input changes
    document.addEventListener('input', (e) => {
      const quantityInput = e.target.closest('.cart-upsell-block__quantity-input');
      if (quantityInput) {
        this.validateQuantity(quantityInput);
      }
    });
  }

  decreaseQuantity(button) {
    const quantityInput = button.parentElement.querySelector('.cart-upsell-block__quantity-input');
    if (!quantityInput) return;

    const currentValue = parseInt(quantityInput.value) || 1;
    const minValue = parseInt(quantityInput.getAttribute('min')) || 1;
    
    if (currentValue > minValue) {
      quantityInput.value = currentValue - 1;
      this.triggerInputEvent(quantityInput);
    }
  }

  increaseQuantity(button) {
    const quantityInput = button.parentElement.querySelector('.cart-upsell-block__quantity-input');
    if (!quantityInput) return;

    const currentValue = parseInt(quantityInput.value) || 1;
    const maxValue = parseInt(quantityInput.getAttribute('max')) || 99;
    
    if (currentValue < maxValue) {
      quantityInput.value = currentValue + 1;
      this.triggerInputEvent(quantityInput);
    }
  }

  validateQuantity(input) {
    const value = parseInt(input.value);
    const minValue = parseInt(input.getAttribute('min')) || 1;
    const maxValue = parseInt(input.getAttribute('max')) || 99;

    if (isNaN(value) || value < minValue) {
      input.value = minValue;
    } else if (value > maxValue) {
      input.value = maxValue;
    }
  }

  triggerInputEvent(input) {
    // Trigger input event for any listeners
    const event = new Event('input', { bubbles: true });
    input.dispatchEvent(event);
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.cartUpsell = new CartUpsell();
});

// Make CartUpsell available globally
window.CartUpsell = CartUpsell;
